import React from 'react'

const CancelFormModal = ({ onCloseFn, message, onAccept }) => {
    return (
        <div className="py-1">
            <div style={{ textAlign: "center" }}>
                <p className="fs17 text-lg" style={{ color: "#4f5b7d" }}>
                    {message}
                </p>
            </div>
            <div>
                <div
                    className="py-2 flex justify-center items-center mt-3"
                    onClose={onCloseFn}
                    style={{ width: "60%", paddingLeft: "40%" }}
                >
                    <button
                        type="button"
                        className="btn btn-lg btn-cancel m-1 text-blue font-semibold"
                        onClick={onCloseFn}
                        style={{
                            height: "40px",
                            width: "110%",
                            borderRadius: "20px",
                            backgroundColor: "rgba(99, 141, 255, 0.1)",
                            margin: "0 21.4px 0 0",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "15px 55px 15px 55px",
                        }}
                    >
                        No
                    </button>
                    <button
                        type="button"
                        onClick={onAccept}
                        className="btn btn-lg btn-open m-1 bg-blue text-white font-semibold"
                        style={{
                            height: "40px",
                            width: "110%",
                            borderRadius: "20px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            margin: "0 21.4px 0 0",
                            padding: "15px 55px 15px 55px",
                        }}
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    )
};

export default CancelFormModal